import React, { FC } from 'react';

import { TooltipValidationSection } from './TooltipValidationSection';
import { MessageValidationSection } from './MessageValidationSection';
import { isMobile } from '../../../utils/device';

import componentChildrenClasses from './styles/componentChildren.module.scss';
import contentValidationBtnTipClasses from './styles/contentValidationBtnTip.module.scss';
import { ControlGroupProps } from '../types';

export const ControlGroupValidationSection: FC<React.PropsWithChildren<ControlGroupProps>> = ({
	children,
	...props
}) => {
	return (
		<div
			className={componentChildrenClasses.componentChildren}
			data-testid='controlGroup__childrenComponent'
		>
			{children}
			{props.validationMessagePlace === 'component' && !props.hideValidationTooltip && (
				<TooltipValidationSection
					{...props}
					className={contentValidationBtnTipClasses.contentValidationBtnTip}
					isMobile={isMobile}
				/>
			)}
			{isMobile && !props.mobileValidationInTooltip && <MessageValidationSection {...props} />}
		</div>
	);
};
